import { Field, Formik } from "formik";
import * as Yup from 'yup';
import { CMDiv } from "./ContactUs.styles";
import Heading from "../../../components/heading/heading.component";
import InputField from "../../../components/Input-field/input-field.component";
import Button from "../../../components/button/button.component";
import Dropdown from "../../../components/dropdown/dropdown.component";
import { Link } from "react-router-dom";
import { useState } from "react";
import { setUpAPI } from "../../../Utils/api.utils";
import UploadFileContactUS from "../../../components/upload-files/upload-files.component";
import Loading from "../../../components/loading/loading.component";

const ContactUs = () => {
  const [submitted, setSubmitted] = useState(false);
  const [open, setOpen] = useState(false);
  const [fileUrl, setFileUrl] = useState(null);
  const [loading,setLoading]=useState(false);

  const options = [
    { value: 'General inquiry', text: 'General inquiry' },
    { value: 'Technical Support', text: 'Technical Support' },
    { value: 'Funds Related', text: 'Funds Related' },
    { value: 'Verification / KYC', text: 'Verification / KYC' },
    { value: 'Auctions & Trading', text: 'Auctions & Trading' }
  ];

  const initialValues = {
    subject: '',
    firstName: '',
    lastName: '',
    email: '',
    message: '',
    file: ''
  };

  const schema = Yup.object().shape({
    subject: Yup.string().required('Subject is required'),
    firstName: Yup.string()
      .matches(/^[\p{L}\p{Script=Han}\s-]+$/u, 'Enter a valid First name')
      .trim()
      .required('First Name is required'),
    lastName: Yup.string()
      .matches(/^[\p{L}\p{Script=Han}\s-]+$/u, 'Enter a valid Last Name')
      .trim()
      .required('Last Name is required'),
    email: Yup.string()
      .email('Invalid email format')
      .min(3, 'Minimum 3 symbols')
      .max(50, 'Maximum 50 symbols')
      .required('Email is required'),
    message: Yup.string()
      .required('Message is required')
      .min(3, 'Minimum 3 symbols')
      .max(150, 'Maximum 150 symbols')
  });

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (values) => {
    console.log(values)
    console.log(fileUrl)
    try {
      setLoading(true)
      const response = await setUpAPI(
        "ContactUs",
        {
          subject: values.subject,
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          message: values.message,
          ...(fileUrl ? { file: fileUrl.fileAbsoluteUrl } : {})
        },
        "POST",
        null
      );
      setSubmitted(true);
      setLoading(false)
      return await response.json();
    
    } catch (error) {

    }
  };

  if (loading) {
    return <Loading />;
  }
  return (
    <div className="App login_page">
      <Heading previusPage={"Contact Us"} />
     
      <Formik
        initialValues={initialValues}
        validationSchema={schema}
        onSubmit={handleSubmit}
      >
        {({ values, errors, touched, handleChange, handleSubmit }) => (
          <>
            <CMDiv className="contact-form">
              {submitted ? (
                <div style={{ width: "70%", textAlign: "justify" }}>
                  <h4>Thank you for reaching out to us!</h4>
                  <p>
                    We’ve received your message and one of our team members will
                    review it shortly.
                  </p>
                </div>
              ) : (
                <>
                  <div className="Column">
                    <label>
                      Subject <span className="error-caption">*</span>
                    </label>
                    <Field
                      as={Dropdown}
                      style={{ maxWidth: "1000px", height: "40px" }}
                      options={options}
                      name="subject"
                      value={values.subject}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="Row">
                    <div className="Column">
                      <label>
                        First Name <span className="error-caption">*</span>
                      </label>
                      <InputField
                        name="firstName"
                        placeholder="First Name"
                        isInvalid={errors.firstName && touched.firstName}
                        error={errors.firstName}
                        value={values.firstName}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="Column">
                      <label>
                        Last Name <span className="error-caption">*</span>
                      </label>
                      <InputField
                        name="lastName"
                        placeholder="Last Name"
                        error={errors.lastName}
                        value={values.lastName}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="Column">
                    <label>
                      Email <span className="error-caption">*</span>
                    </label>
                    <InputField
                      className="email-field form-control"
                      name="email"
                      type="email"
                      placeholder="Email"
                      isInvalid={errors.email && touched.email}
                      error={errors.email}
                      value={values.email}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="ColumnTextArea">
                    <label>
                      Your Message <span className="error-caption">*</span>
                    </label>
                    <Field
                      as="textarea"
                      name="message"
                      className="CUSmessage textarea"
                      error={errors.message}
                      value={values.message}
                      onChange={handleChange}
                    />
                    <div className="File">
                      <Link type="link" onClick={handleOpen}>
                        Upload File
                      </Link>
                      <p>{fileUrl ? fileUrl.fileRelativeUrl : ""}</p>

                    </div>
                    

                    <Button
                      type="button"
                      className="butonContactUs"
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </div>
                </>
              )}
            </CMDiv>
          </>
        )}
      </Formik>
      {open && (
        <UploadFileContactUS
          open={open}
          handleClose={handleClose}
          title={"Upload File"}
          setFileUrl={setFileUrl}
        />
      )}
    </div>
  );
};

export default ContactUs;
